<div class="dialog-title">
    <h3> {{'users.changePass' | translate}}</h3>

    <span mat-button mat-dialog-close>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path id="close-ic"
                d="M209,306.662l-4.986,4.986a1.175,1.175,0,1,1-1.662-1.662L207.338,305l-4.986-4.986a1.175,1.175,0,1,1,1.662-1.662L209,303.338l4.986-4.986a1.175,1.175,0,1,1,1.662,1.662L210.662,305l4.986,4.986a1.175,1.175,0,1,1-1.662,1.662Z"
                transform="translate(-202 -298)" fill="#8479ac" />
        </svg>
    </span>



</div>
<mat-dialog-content>
    <div class="register-user">
        <form (ngSubmit)="onResetSubmit()" [formGroup]="resetPassForm">
            <div class="inputs-form-section" [hidden]="!this.data.showOldPassword">
                <mat-form-field appearance="outline">
                    <mat-label>{{'auth.Current Password' | translate}}</mat-label>
                    <input matInput placeholder="" [required]="data.showOldPassword"
                        [type]="hide_oldPass ? 'password' : 'text'" formControlName="old_password" 
                        autocomplete="off" autocomplete="new-password" maxlength="50">
                    <mat-icon matSuffix style="color: #70639E;" mat-icon-button (click)="hide_oldPass = !hide_oldPass"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide_oldPass">{{hide_oldPass ?
                        'visibility_off' :
                        'visibility'}}</mat-icon>
                    <mat-error *ngIf="hasError('old_password', 'required')">
                        {{'validations.required' | translate}}
                    </mat-error>
                    <mat-error *ngIf="hasError('old_password', 'pattern')">
                        {{'validations.password' | translate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="inputs-form-section">
                <mat-form-field appearance="outline">
                    <mat-label>{{'auth.New Password' | translate}}</mat-label>
                    <input matInput placeholder="" [type]="hide ? 'password' : 'text'" formControlName="password"
                        required autocomplete="off" autocomplete="new-password" maxlength="50" minlength="8">
                    <mat-icon matSuffix style="color: #70639E;" mat-icon-button (click)="hide = !hide"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">{{hide ? 'visibility_off' :
                        'visibility'}}</mat-icon>
                    <mat-error *ngIf="hasError('password', 'required')">
                        {{'validations.required' | translate}}
                    </mat-error>
                    <mat-error *ngIf="hasError('password', 'pattern')">
                        {{'validations.password' | translate}}
                    </mat-error>
                    <!-- <mat-error *ngIf="hasError('password', 'minlength')">
                        {{'validations.minlength' | translate}} 8
                    </mat-error> -->
                </mat-form-field>
            </div>



            <div class="inputs-form-section">
                <mat-form-field appearance="outline">
                    <mat-label>{{'auth.Confirm new Password' | translate}}</mat-label>
                    <input matInput placeholder="" [type]="hide_confirmPass ? 'password' : 'text'"
                        formControlName="cPassword" required autocomplete="off" autocomplete="new-password"
                        maxlength="50" minlength="8">
                    <mat-icon matSuffix style="color: #70639E;" (click)="hide_confirmPass = !hide_confirmPass"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide_confirmPass">{{hide_confirmPass ?
                        'visibility_off' :
                        'visibility'}}</mat-icon>
                    <mat-error *ngIf="hasError('cPassword', 'required')">
                        {{'validations.required' | translate}}
                    </mat-error>
                    <mat-error *ngIf="hasError('cPassword', 'pattern')">
                        {{'validations.password' | translate}}
                    </mat-error>
                    <mat-error *ngIf="hasError('cPassword', 'notMatch')">
                        {{'validations.Password-match' | translate}}
                    </mat-error>
                    <!-- <mat-error *ngIf="hasError('cPassword', 'minlength')">
                        {{'validations.minlength' | translate}} 8
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="group_btn">
                <button class="btnLight_fill" mat-button mat-dialog-close *ngIf="!loading">
                    {{'users.CANCEL' | translate}}

                </button>
                <button class="btn_fill" mat-button type="submit" [appLoading]="loading">
                    {{'users.SAVE NEW PASSWORD' | translate}}

                </button>
            </div>

        </form>

    </div>
</mat-dialog-content>